import { createSimpleEvent } from '@passionware/simple-event';
import { setApiClientCommunicationListener } from 'lib/api/apiClientLifecycle';
import { ApiClientCommunicationEvent } from './apiClientCommunicationEvent';

export const apiClientCommunicationEvent =
  createSimpleEvent<ApiClientCommunicationEvent>();

let registered = false;

export function registerApiClientCommunicationEvent() {
  if (registered) {
    return;
  }
  registered = true;
  setApiClientCommunicationListener(event => {
    apiClientCommunicationEvent.emit(event);
  });
}
